import type { createServerSupabaseClient } from "@/lib/supabase-server";

type ServerSupabase = Awaited<ReturnType<typeof createServerSupabaseClient>>;

/** Bump the suffix to show the notice again after a policy change. */
export const SHOWCASE_NOTICE_STORAGE_KEY = "pw-showcase-notice-dismissed-v1";

/**
 * Whether to show the one-time "we feature candidate profiles" notice on the
 * signed-in home: the user has a candidate profile with at least one
 * availability window (so they could be featured) and has not opted out.
 * Reads the user's own row under RLS. Fails quiet: any error hides it.
 */
export async function readShowcaseNoticeEligible(input: {
  supabase: ServerSupabase;
  userId: string;
}): Promise<boolean> {
  try {
    const { data, error } = await input.supabase
      .from("profiles")
      .select("public_showcase, availability_windows(id)")
      .eq("user_id", input.userId)
      .maybeSingle();
    if (error || !data) return false;
    const row = data as unknown as {
      public_showcase: boolean | null;
      availability_windows: { id: string }[] | null;
    };
    return row.public_showcase === true && (row.availability_windows?.length ?? 0) > 0;
  } catch {
    return false;
  }
}
